import { useEffect } from 'react';

import { Drawer, Flex, Toaster } from '@grupoboticario/flora-react';
import { useLocation } from 'react-router-dom';

import config from 'config';
import { QUERYPARAMS } from 'config/environments/shared';
import { FloraProvider } from 'containers/ProviderComposer/providers/FloraProvider';
import { getPaymentStatus } from 'helpers';
import { usePaymentDetail, useDrawer, useTracking } from 'hooks';
import { newRelicMonitoringService } from 'services';

import { Details, Infos, OtherOptions } from './components';
import { HeaderContentPayment } from '../components/HeaderContentPayment/HeaderContentPayment';
import Styles from '../Drawers.styles';

export const PaymentDetail = () => {
  const { isOpen, closeDrawer, searchParams } = useDrawer('PaymentDetail');
  const { data, isSuccess, isError } = usePaymentDetail(
    searchParams.get(QUERYPARAMS.PAYMENT_ID) || ''
  );
  const isLateOrder = data?.paymentStatus === 'open' && data.status === 'overdue';
  const { sendDataToGTM } = useTracking();
  const { pathname } = useLocation();
  const paymentStatus = getPaymentStatus({
    daysLate: data?.daysLate || 0,
    daysUntilDueDate: data?.daysUntilDueDate || 0,
    paymentStatus: data?.paymentStatus || '',
    status: data?.status || '',
  });

  useEffect(() => {
    if (isSuccess) {
      sendDataToGTM({
        event: 'page_view',
        event_parameters: {
          page_location: `${config.app.url}${pathname.substring(1)}/detalhes-do-pagamento`,
          page_title: 'Detalhes do Pagamento',
          transaction_id: data.orderId,
          cd_metodo_pagamento: data.planDetail.toLowerCase(),
          cd_status_pagamento: paymentStatus?.tag.toLowerCase(),
          cd_dias_para_vencimento: data.daysUntilDueDate,
          cd_dias_apos_vencimento: data.daysLate,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isSuccess]);

  useEffect(() => {
    if (isError) {
      Toaster.notify({
        kind: 'error',
        description: `Não foi possível exibir os detalhes do pagamento. Por favor, tente novamente.`,
        origin: 'right-top',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  if (isError) {
    return null;
  }

  if (Boolean(paymentStatus?.tag === 'Pago') || Boolean(paymentStatus?.tag === 'Vencido')) {
    Toaster.notify({
      kind: 'error',
      description: `Não foi possível exibir os detalhes de um titulo pago ou vencido`,
      origin: 'right-top',
    });

    if (data) {
      newRelicMonitoringService.addPageAction('callback_ver_detalhes', {
        cd_interaction_detail: 'erro',
        cd_numero_pedido: `${data.orderId}`,
      });
    }

    closeDrawer();

    return null;
  }

  return (
    <Drawer open={isOpen && isSuccess} onOpenChange={closeDrawer}>
      <Styles.DrawerContent side='right'>
        <FloraProvider>
          <Styles.DrawerHeader>
            <HeaderContentPayment title='Detalhes do pagamento' />
          </Styles.DrawerHeader>
          <Styles.DrawerBody>
            {data && (
              <Flex align='center' direction='column'>
                <Details />
                <Infos />
                {isLateOrder ? <OtherOptions /> : null}
              </Flex>
            )}
          </Styles.DrawerBody>
        </FloraProvider>
      </Styles.DrawerContent>
    </Drawer>
  );
};
